<template>
<ion-card>
  <ion-list>
    <ion-item lines="none" color="light" @click.stop="verHistorial">
      <ion-thumbnail slot="start" v-if="equipo.imagenes && equipo.imagenes[0]">
        <ion-img :src="equipo.imagenes[0].imagen"></ion-img>
      </ion-thumbnail>
      <ion-note slot="start" v-else color="primary">
        <i class="icon ion-ios-cog icon-lg"></i>
      </ion-note>
      <ion-label text-wrap>
        <h2>{{equipo.alias || equipo.sn}}</h2>
        <p>{{equipo.marca}} {{equipo.modelo}} {{equipo.sn}}</p>
        <p>{{equipo.tipo}}</p>
        <p v-if="custodia._id">Última custodia: {{custodia.fecha | moment('MMM DD')}}, {{custodia.tipoCustodia}}</p>
      </ion-label>
      <ion-note slot="end" v-if="link">Ver historial</ion-note>
    </ion-item>
  </ion-list>
</ion-card>
</template>
<script>
import Api from '@/components/Api/Api'
export default {
  name: 'TarjetaEquipo',
  props: {
    id: {
      type: String,
      default: ''
    },
    link: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      equipo: {},
      custodias: [],
      custodia: {}
    }
  },
  async mounted() {
    console.log("TarjetaEquipo", this.id)
    if (this.id && this.id != '') {
      this.equipo = await Api.get('equipo', this.id)
      this.custodias = (await Api.find('custodia', ['idEquipo,eq,' + this.id], {
          subset: [{
            coleccion: 'directorio',
            alias: 'autor',
            query: '_id,eq,',
            sustituir: 'idAutor',
            unico: true
          }]
        }))
        .sort((a, b) => a.fecha < b.fecha ? 1 : -1)
      if (this.custodias[0])
        this.custodia = this.custodias[0]
      console.log("Custodia?", this.custodias, this.custodia)

    }
  },
  methods: {
    verHistorial() {
      // Validar que tenemos un ID y que el link está habilitado
      if (this.link && this.id && this.id !== '') {
        this.$router.push('/catalogos/equipos/' + this.id + '/modo/historial')
      }
    }
  }
}
</script>
